import { getAppSource, saveAppSource } from './AppSource';

const KEYS = {
  mockedUsageData: 'mockedUsageData',
  usageDevButtonsEnabled: 'usageDevButtonsEnabled',
};

export const setMockedUsageData = (data) => sessionStorage.setItem(KEYS.mockedUsageData, JSON.stringify(data));

export const getMockedUsageData = () => JSON.parse(sessionStorage.getItem(KEYS.mockedUsageData) || 'null');

export const removeMockedUsageData = () => sessionStorage.removeItem(KEYS.mockedUsageData);

export const getUsageDevButtonsEnabled = () => sessionStorage.getItem(KEYS.usageDevButtonsEnabled) === 'true';

export const clearBrowserStorage = () => {
  const appSource = getAppSource();

  localStorage.clear();
  sessionStorage.clear();

  saveAppSource(appSource);
};
